export default __webpack_public_path__ + "static/media/DragIcon.92d0e818.svg";